'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, ReactReduxContext } from 'react-redux';
import { getHasTemplate } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { validate } from 'page-editor-ui/redux/actions/pagePublishActions';
import withEditorActionsAndEvents from 'ContentEditorUI/components/hoc/withEditorActionsAndEvents';
import SaveShortcutChecker from 'ContentEditorUI/coffee/lib/SaveShortcutChecker';

// Legacy stuff
import OldIndexControllerBusEventHandlers from 'ContentEditorUI/legacyHoldingPattern/oldIndexControllerBusEventHandlers';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isMissingTemplate: !getHasTemplate(state)
});
const mapDispatchToProps = {
  validate
};
class LegacyPageScaffoldingContainer extends Component {
  componentDidMount() {
    const {
      isMissingTemplate,
      saveActions,
      bus
    } = this.props;

    // Legacy, unported logic pushed to the side for now
    const oldIndexControllerBusEventHandlers = new OldIndexControllerBusEventHandlers(this.storeRef, saveActions, bus);
    oldIndexControllerBusEventHandlers.registerAllLegacyEvents();
    if (!isMissingTemplate) {
      SaveShortcutChecker.listenForSaveRequest(() => saveActions.save());
      this.props.validate();
    }
  }

  // This should only ever be rendered once
  shouldComponentUpdate() {
    return false;
  }
  saveStoreRefAndReturnNull(store) {
    this.storeRef = store;
    return null;
  }
  render() {
    return /*#__PURE__*/_jsx(ReactReduxContext.Consumer, {
      children: ({
        store
      }) => this.saveStoreRefAndReturnNull(store)
    });
  }
}
LegacyPageScaffoldingContainer.propTypes = {
  isMissingTemplate: PropTypes.bool.isRequired,
  saveActions: PropTypes.object.isRequired,
  bus: PropTypes.object.isRequired,
  validate: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(withEditorActionsAndEvents(LegacyPageScaffoldingContainer));